import { exportToExcel, generateExcelFiles } from "../../../utils/excel";
import { successToast, errorToast } from "../../../utils/toast";
import { getTableDynamicConfig } from "../../../lib/services/forceBI";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
const prepareForExcel = config => {
  var _config$columns;
  let finalConfig = [];
  config === null || config === void 0 ? void 0 : (_config$columns = config.columns) === null || _config$columns === void 0 ? void 0 : _config$columns.forEach(current => {
    var _config$data;
    config === null || config === void 0 ? void 0 : (_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.forEach((row, index) => {
      const value = row[current.id];
      if (!(finalConfig !== null && finalConfig !== void 0 && finalConfig[index])) finalConfig[index] = {};
      finalConfig[index][current.label] = value;
    });
  });
  return finalConfig;
};
export const downloadTable = _ref => {
  let {
    title,
    data,
    t
  } = _ref;
  return exportToExcel({
    data: prepareForExcel(data),
    fileName: title
  }).then(() => {
    if (t) successToast({
      t,
      text: t('label_file_downloaded')
    });
  }).catch(_ref2 => {
    let {
      error
    } = _ref2;
    if (error === 'NoData') {
      errorToast({
        t,
        text: t('label_file_no_data_to_export')
      });
    } else {
      errorToast({
        t,
        text: t('label_file_download_error')
      });
    }
  });
};
export const downloadMultipleTables = _ref3 => {
  let {
    widgets,
    dashboardFilters,
    forceBIUtils,
    t
  } = _ref3;
  const {
    processDataToSendFromWidget
  } = forceBIUtils;
  let promises = widgets.reduce((arr, current) => {
    const finalData = processDataToSendFromWidget({
      data: current,
      dashboardFilters: dashboardFilters
    });
    arr.push(getTableDynamicConfig(finalData));
    return arr;
  }, []);
  return Promise.all(promises).then(responses => {
    responses.forEach(response => {
      if (!response.data) {
        console.error(`There is one table that couldn't be downloaded`);
      } else {
        const data = response.data;
        downloadTable({
          title: data.title,
          data: data,
          t
        });
      }
    });
  });
};
export const downloadMultipleTablesAsZip = _ref4 => {
  let {
    widgets,
    dashboardFilters,
    forceBIUtils,
    t,
    dashboardName,
    fileName
  } = _ref4;
  const {
    processDataToSendFromWidget
  } = forceBIUtils;
  let promises = widgets.reduce((arr, current) => {
    const finalData = processDataToSendFromWidget({
      data: current,
      dashboardFilters: dashboardFilters
    });
    arr.push(getTableDynamicConfig(finalData));
    return arr;
  }, []);
  const zip = new JSZip();
  const folder = zip.folder(dashboardName || t('label_charts'));
  return Promise.all(promises).then(responses => {
    var _responses$map;
    const tables = [];
    let data = (responses === null || responses === void 0 ? void 0 : (_responses$map = responses.map(current => current.data)) === null || _responses$map === void 0 ? void 0 : _responses$map.filter(current => {
      var _current$data;
      return current === null || current === void 0 ? void 0 : (_current$data = current.data) === null || _current$data === void 0 ? void 0 : _current$data.length;
    })) || [];
    if (!(data !== null && data !== void 0 && data.length)) {
      errorToast({
        t,
        text: t('label_selected_widgets_empty_no_download')
      });
      return Promise.resolve();
    }
    data.forEach(current => {
      const table = prepareForExcel(current);
      // Prevent to add empty excels
      if (current.data.length) tables.push({
        data: table,
        name: current.title,
        id: current.id
      });
    });
    const files = generateExcelFiles(tables);

    // If there are files with duplicated names, only one of them will be added to the folder
    files.forEach(file => folder.file(file.name, file.data));
    return zip.generateAsync({
      type: 'blob'
    }).then(content => {
      let zipName = `${t('label_data').toLowerCase()}.zip`;
      if (fileName) zipName = `${fileName.toLowerCase()}.zip`;
      saveAs(content, zipName);
      successToast({
        t,
        text: t('label_files_downloaded')
      });
    }).catch(err => {
      console.error('Error generating zip:', err);
    });
  });
};